let Hooks = {}

Hooks.Countdown = {
    mounted() {
        this.start();
    },

    updated() {
        if (this.el.dataset.restart !== this.restart) this.start();
    },

    destroyed() {
        clearInterval(this.timer);
    },

    value() {
        return this.el.querySelector("#offline-countdown-value");
    },

    start() {
        clearInterval(this.timer);
        this.restart = this.el.dataset.restart;
        this.remaining = parseInt(this.el.dataset.seconds, 10);
        this.render();

        this.timer = setInterval(() => {
            this.remaining -= 1;
            this.render();
            if (this.remaining <= 0) clearInterval(this.timer);
        }, 1000);
    },

    render() {
        this.value().textContent = this.el.dataset.format.replace("%{seconds}", Math.max(this.remaining, 0));
    }
}

export {Hooks}
